import React, { useEffect } from "react";
import { Navigate as RouterNavigate, NavigateProps as RouterNavigateProps } from "react-router-dom";

import { useUnsafeNavigationControls } from "./use-navigation-control-context";

export interface NavigateProps extends RouterNavigateProps {
  // Extending the original NavigateProps if needed
}

/**
 * Custom Navigate component that extends React Router's Navigate with navigation tracking
 * @param props - Component props including standard Navigate props
 */
export const Navigate: React.FC<NavigateProps> = ({ to, replace = false, state, ...rest }) => {
  const maybeNavigationControls = useUnsafeNavigationControls();

  // Track the navigation when the component mounts
  useEffect(() => {
    // Convert 'to' to string for tracking
    const toStr = typeof to === "string" ? to : to.pathname || "";

    // Track the navigation event
    maybeNavigationControls?.trackNavigation(toStr, { replace });

    // Only run this effect once when the component mounts
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <RouterNavigate to={to} replace={replace} state={state} {...rest} />;
};
